import { render, staticRenderFns } from "./PemegangModal.vue?vue&type=template&id=04e4f605&scoped=true&lang=pug&"
import script from "./PemegangModal.vue?vue&type=script&lang=js&"
export * from "./PemegangModal.vue?vue&type=script&lang=js&"
import style0 from "./PemegangModal.vue?vue&type=style&index=0&id=04e4f605&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e4f605",
  null
  
)

export default component.exports